module.exports = new __parcel__URL__("dark-side-of-the-moon.b1205143.jpg").toString();